import { useGetIdentity, usePermissions } from 'react-admin';
import { useGateOperatorAccounts } from '../gates/hooks/useGateOperatorAccounts';
import { menuEntriesFor, type MenuEntry } from './menuEntries';

// The same two rules the old AdminMenu and GatesMenu applied.
export function useMenuEntries(): MenuEntry[] {
    const { identity } = useGetIdentity();
    const { permissions } = usePermissions();
    const { accountIds } = useGateOperatorAccounts();
    return menuEntriesFor({
        showAdminGroup: permissions === 'admin',
        showOperatorGates: identity?.role !== 'admin' && accountIds.length > 0,
    });
}
